import { fetchWithAuth } from './fetchWithAuth';
import axios from 'axios';


export async function addCartItem(userId, itemId) {
  const payload = { user_id: Number(userId), item_id: Number(itemId) };
  const res = await fetchWithAuth('/api/cart/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const text = await res.text();
  const contentType = res.headers.get('content-type') || '';
  const body = contentType.includes('application/json') && text ? JSON.parse(text) : text;

  if (!res.ok) {
    const err = new Error((body && body.message) || text || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  return body;
}

export async function deleteCartItem(userId, itemId) {
  const payload = { user_id: Number(userId), item_id: Number(itemId) };
  const res = await fetchWithAuth('/api/cart/', {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const text = await res.text();
  const contentType = res.headers.get('content-type') || '';
  const body = contentType.includes('application/json') && text ? JSON.parse(text) : text;

  if (!res.ok) {
    const err = new Error((body && body.message) || text || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  return body;
}

export async function getCart(userId) {
  const path =  `/api/cart/${Number(userId)}`;
  const res = await fetchWithAuth(path, { method: 'GET' });

  const text = await res.text();
  const contentType = res.headers.get('content-type') || '';
  const body = contentType.includes('application/json') && text ? JSON.parse(text) : text;

  if (!res.ok) {
    const err = new Error((body && body.message) || text || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  return body;
}

export async function confirmOrder(userId, orderId) {
  const payload = { user_id: Number(userId), order_id: orderId };
  const res = await fetchWithAuth('/api/cart/confirm', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const text = await res.text();
  const contentType = res.headers.get('content-type') || '';
  const body = contentType.includes('application/json') && text ? JSON.parse(text) : text;

  if (!res.ok) {
    const err = new Error((body && body.message) || text || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  return body;
}

export async function createCardcomCheckout({ TerminalNumber, ApiName, ApiPassword, SuccessRedirectUrl, FailedRedirectUrl, WebHookUrl, Amount, ReturnValue, user, products }) {
  const body = {
    TerminalNumber,
    ApiName,
    ApiPassword,
    Operation: 'ChargeOnly',
    ReturnValue,
    Amount,
    SuccessRedirectUrl,
    FailedRedirectUrl,
    WebHookUrl,
    Document: {
      Name: user?.name || '',
      Email: user?.email || '',
      DocumentTypeToCreate: 'Order',
      Products: products
    }
  };
  const res = await axios.post(process.env.REACT_APP_CARDCOM_URL_CREATE, body);
  return res.data;
}

export async function createOrder({ return_value, user_id, total_price, items }) {
  const payload = { return_value, user_id, total_price, items };
  const res = await fetchWithAuth('/api/orders/order', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  const text = await res.text();
  const contentType = res.headers.get('content-type') || '';
  const body = contentType.includes('application/json') && text ? JSON.parse(text) : text;
  if (!res.ok) {
    const err = new Error((body && body.message) || text || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

export async function fetchCoupons(userId) {
  const res = await fetchWithAuth(`/api/coupons/${userId}`);
  return res.json();
}

export async function checkCoupon({ userId, items, couponCode }) {
  const BASE_URL = process.env.REACT_APP_BASE_URL || '';
  const res = await fetch(`${BASE_URL}/api/cart/check-coupon`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId, items, coupon_code: couponCode })
  });
  return res.json();
}

export async function createOrderAndGetPaymentUrl({ userId, items, coupon_id, coupon_discount }) {
  const res = await fetchWithAuth('/api/orders/order', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId, items, coupon_id: coupon_id, coupon_discount })
  });
  return res.json();
}

export default {createOrder, createCardcomCheckout, getCart, addCartItem, deleteCartItem, confirmOrder, fetchCoupons, checkCoupon, createOrderAndGetPaymentUrl};
